import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import DOMPurify from 'dompurify';
import { useFormContext } from 'react-hook-form';
import { useCallback } from 'react';
function Discount(props) {
    const { title, copy, amount: discountAmount, min, max, } = props;
    const { watch } = useFormContext();
    const amount = watch('amount');
    const formatContent = useCallback((content) => content
        .replace('{amount}', `${discountAmount}`)
        .replace('{min}', `${min}`)
        .replace('{max}', `${max}`), [amount]);
    return (_jsxs("div", { className: "form__section discount", children: [_jsxs("div", { className: "discount__content", children: [_jsx("span", { className: "h5 discount__title", children: formatContent(title) }), _jsx("div", { className: "discount__copy", dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(formatContent(copy)) } })] }), _jsxs("div", { className: "discount__breakdown", children: [_jsxs("span", { className: "discount__total", children: ["\u00A3", amount + discountAmount] }), _jsxs("span", { className: "discount__amount", children: ["\u00A3", discountAmount, ' ', "for FREE"] }), _jsxs("span", { className: "discount__discounted", children: ["\u00A3", amount] })] })] }));
}
export default Discount;
